import { axiosInstance } from "./axios-config";

export class BlogCategoryApi {
  /**
   * @param {Object} params - Query parameters
   * @param {number} [params.pageNo=1] - Page number (1-based, backend subtracts 1 internally)
   * @param {number} [params.pageSize=10] - Number of categories per page
   * @returns {Promise<CategoryListResponse>}
   */
  getAll = async (params = {}) => {
    const response = await axiosInstance.get("/blog/categories/category-list", {
      params: {
        pageNo: params.pageNo ?? 1,
        pageSize: params.pageSize ?? 10,
      },
    });

    return response;
  };
}
